import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static targets = [
    "container", 
    "template", 
    "idNumber",
    "idNumberLabel",
    "idNumberNotice",
    "idNumberError",
    "issuingCountryWrapper",
    "issuingCountry",
    "issuingCountryError"
  ]

  connect() {
    this.initializeIssuingCountries()
    this.initializeIdValidation()

    // Intercept the form submission
    this.form = this.element.closest("form")
    if (this.form) {
      this.form.addEventListener("submit", (e) => {
        if (!this.validateAll()) {
          e.preventDefault()
          e.stopPropagation()
          alert("Please fix the errors in representative IDs before continuing.")
        }
      })
    }
  }

  add(event) {
    event.preventDefault()
    const timestamp = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.initializeIssuingCountries()
    this.initializeIdValidation()
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest(".nested-fields")
    if (!item) return
    const destroyField = item.querySelector('input[name*="_destroy"]')
    const isRequired = item.dataset.newRecord === "false" && item.dataset.required === "true"
    if (isRequired) {
      alert("This representative cannot be removed.")
      return
    }
    if (destroyField) {
      destroyField.value = "1"
      item.style.display = "none"
    } else {
      item.remove()
    }
  }

  idTypeChanged(event) {
    const wrapper = event.target.closest(".nested-fields")
    const type = event.target.value
    const idNumber = wrapper.querySelector('input[data-representative-target="idNumber"]')
    const idLabel = wrapper.querySelector('label[data-representative-target="idNumberLabel"]')
    const idNotice = wrapper.querySelector('[data-representative-target="idNumberNotice"]')
    const idError = wrapper.querySelector('[data-representative-target="idNumberError"]')
    const countryWrapper = wrapper.querySelector('[data-representative-target="issuingCountryWrapper"]')
    const countrySelect = wrapper.querySelector('[data-representative-target="issuingCountry"]')
    const countryError = wrapper.querySelector('[data-representative-target="issuingCountryError"]')

    if (type === "passport") {
      countryWrapper.style.display = ""
      idLabel.textContent = "Passport Number"
      idNotice.textContent = ""
    } else {
      countryWrapper.style.display = "none"
      idLabel.textContent = "National ID"
      idNotice.textContent = "Format: 63-4566467N67"
      countrySelect.value = ""
      countryError.classList.add("d-none")
      countryError.textContent = ""
    }

    idError.classList.add("d-none")
    idError.textContent = ""
  }

  validateIdNumber(wrapper) {
    const type = wrapper.querySelector('input[name*="[id_type]"]:checked')?.value
    const idNumber = wrapper.querySelector('input[data-representative-target="idNumber"]')
    const idError = wrapper.querySelector('[data-representative-target="idNumberError"]')
    const countrySelect = wrapper.querySelector('[data-representative-target="issuingCountry"]')
    const countryError = wrapper.querySelector('[data-representative-target="issuingCountryError"]')

    let valid = true
    idError.classList.add("d-none")
    idError.textContent = ""
    countryError.classList.add("d-none")
    countryError.textContent = ""

    if (type === "nationalid") {
      const regex = /^\d{2}-\d{7}[A-Z]\d{2}$/i
      if (!regex.test(idNumber.value)) {
        valid = false
        idError.textContent = "Invalid Zimbabwean ID. Example: 63-4535563N67"
        idError.classList.remove("d-none")
      }
    } else if (type === "passport") {
      if (idNumber.value.length < 3) {
        valid = false
        idError.textContent = "Passport number is too short."
        idError.classList.remove("d-none")
      }
      if (countrySelect.value === "") {
        valid = false
        countryError.textContent = "Please select issuing country."
        countryError.classList.remove("d-none")
      }
    }

    return valid
  }

  // ✅ Validate all representatives before form submission
  validateAll() {
    let allValid = true
    this.containerTarget.querySelectorAll(".nested-fields").forEach(wrapper => {
      if (!this.validateIdNumber(wrapper)) {
        allValid = false
      }
    })
    return allValid
  }

  initializeIssuingCountries() {
    this.containerTarget.querySelectorAll('[data-representative-target="issuingCountry"]').forEach(select => {
      if (!select.dataset.slim) {
        new SlimSelect({ select, placeholder: "Select Country" })
        select.dataset.slim = true
      }
    })
  }

  initializeIdValidation() {
    this.containerTarget.querySelectorAll('[data-representative-target="idNumber"]').forEach(input => {
      input.addEventListener("input", (e) => {
        const wrapper = e.target.closest(".nested-fields")
        this.validateIdNumber(wrapper)
      })
    })

    this.containerTarget.querySelectorAll('input[name*="[id_type]"]').forEach(radio => {
      radio.addEventListener("change", (e) => this.idTypeChanged(e))
    })
  }
}
